export const equalityCategories = [
  "equality_1",
  "equality_2",
  "equality_3",
  "equality_4",
  "equality_5",
  "equality_6",
  "equality_7",
  "equality_8",
  "equality_9",
  "equality_10",
  "equality_11",
  "equality_12",
  "equality_13",
  "equality_14",
  "equality_15",
  "equality_16",
  "equality_17",
  "equality_18",
  "equality_19",
  "equality_20",
  "equality_21",
  "equality_22",
];

export const effectivenessCategories = [
  "effectiveness_1",
  "effectiveness_2",
  "effectiveness_3",
  "effectiveness_4",
  "effectiveness_5",
  "effectiveness_6",
  "effectiveness_7",
  "effectiveness_8",
  "effectiveness_9",
  "effectiveness_10",
  "effectiveness_11",
  "effectiveness_12",
  "effectiveness_13",
  "effectiveness_14",
  "effectiveness_15",
  "effectiveness_16",
  "effectiveness_17",
  "effectiveness_18",
  "effectiveness_19",
  "effectiveness_20",
  "effectiveness_21",
  "effectiveness_22",
  "effectiveness_23",
  "effectiveness_24",
  "effectiveness_25",
  "effectiveness_26",
];

export const effectivenessPersonalCategories = [
  "effectiveness_personal_1",
  "effectiveness_personal_2",
  "effectiveness_personal_3",
  "effectiveness_personal_4",
];

export const safetyCategories = [
  "safety_1",
  "safety_2",
  "safety_3",
  "safety_4",
  "safety_5",
  "safety_6",
  "safety_7",
  "safety_8",
  "safety_9",
  "safety_10",
  "safety_11",
  "safety_12",
  "safety_13",
  "safety_14",
  "safety_15",
  "safety_16",
  "safety_17",
  "safety_18",
  "safety_19",
  "safety_20",
  "safety_21",
  "safety_22",
  "safety_23",
  "safety_24",
  "safety_25",
  "safety_26",
];

export const equalityMapping = {
  1: "Strongly Disagree",
  2: "Disagree",
  3: "Slightly Disagree",
  4: "Neither Agree nor Disagree",
  5: "Slightly Agree",
  6: "Agree",
  7: "Strongly Agree",
};

export const yesNoMapping = {
  No: "No",
  Yes: "Yes",
};

export const effectivenessPersonalMapping = {
  1: "Not at all true for me",
  2: "Untrue for me",
  3: "Somewhat untrue for me",
  4: "Somewhat true for me",
  5: "True for me",
  6: "Very true for me",
};

export const safetyMapping = {
  1: "Strongly Disagree",
  2: "Disagree",
  3: "Neither Agree nor Disagree",
  4: "Agree",
  5: "Strongly Agree",
};

export const equalityCategoriesValue = ["1", "2", "3", "4", "5", "6", "7"];
export const effectivenessPersonalValue = ["1", "2", "3", "4", "5", "6"];
export const safetyValue = ["1", "2", "3", "4", "5"];
export const yesNoValue = ["No", "Yes"];
